import React from 'react'
import loaderGif from '../assets/images/loader.gif'
//@mui
import Box from '@mui/material/Box'
import Paper from '@mui/material/Paper'
import Typography from '@mui/material/Typography'

const ComingSoon = ({ pageTitle, info, noPaper }) => (
  <Box
    display="flex"
    flexDirection="column"
    alignItems="center"
    padding={8}
    component={!noPaper && Paper}
  >
    <Box component="img" src={loaderGif} width={100} display="flex" />
    <Typography variant="title">{pageTitle || 'Coming Soon'}</Typography>
  </Box>
)

export default ComingSoon
